<template lang="">
  <!-- <v-container fluid> -->
  <div id="fullscreen">
    <v-img :src="publicStateUrl()" alt="image" :height="ImageHeight" :width="ImageWidth"></v-img>
  </div>
  <!-- </v-container> -->
</template>
<script>
export default {
  name: 'Error404',
  data() {
    return {
      errorImage: "../../../assets/error_404.svg",
      ImageHeight: "100%",
      ImageWidth: "100%",
    }
  },
  methods: {
    isXsLayout() {
      if (this.$vuetify.breakpoint.name === 'xs') {
        return true;
      }
      return false;
    },
    publicStateUrl() {
      return this.isXsLayout() ? require('../../../assets/error_404_sp.svg') : require('../../../assets/error_404.svg');
    },
  },
  created() {
    const layout = this.isXsLayout();
    if (layout) {
      this.ImageHeight = "627px";
      this.ImageWidth = "375px";
    }
  }
}
</script>

<style>
  #fullscreen {
    position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: #000;
  }
  #fullscreen img {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    max-height: 80%;
    margin: auto;
  }
</style>